//
//

export default {
    name: "CollapsableContainer",
    props: {
        title: {
            type: String,
            default: ""
        },
        display: Boolean
    },
    data() {
        return {
            isCollapsed: false
        };
    }
};
